<div class="flex items-center gap-6 mt-2 w-fit" [class.leaving]="leaving()">
  <span class="text-xs text-shikenso-purple-base-60">
    {{ 'components.filteredCreatorBadge.filteredCreator' | translate }}
  </span>

  <div
    class="flex items-center gap-2 pl-[3px] rounded-full bg-shikenso-pink-base-60 border border-shikenso-purple-base-12"
  >
    <app-icon-badge
      [content]="creatorIcon()"
      [fallbackText]="creatorName()"
      [size]="20"
      [iconSize]="20"
      [fontSize]="8"
      [borderRadius]="100"
    />
    <span class="text-xs font-medium">{{ creatorName() }}</span>

    <button mat-icon-button type="button" class="flex items-center justify-center ml-1" (click)="startLeave()">
      <app-icon src="/icons/x-mark.svg" alt="Remove" [size]="12" />
    </button>
  </div>
</div>
